<template>
    <div class="rightPage" style="position: relative;">
      <!-- 悬浮在页面上的主观题窗口 -->
      <div v-if="showZg" style="position: absolute; top: 0; left: 0; width: 100%; min-height: 100vh; background: rgba(0,0,0,0.5); z-index: 999; color: white;">
        <!-- <el-button @click="cancelCanvas" type="primary">退 出 页 面</el-button> -->
  
        <div style="float: left; padding-top: 40px;" id="canvasDiv">
          <!-- 画布 （画布点击事件） -->
          <canvas id="myCanvas3" :width="canvasWidth" :height="canvasHeight" @click.stop="canvasClick"></canvas>
          <!-- 批阅记录(分数，√× 等) -->
          <scorePoint 
            ref="scorePoint" 
            :w="item.w" :h="item.h" :x="item.showX" :y="item.showY" :id="item.index" :arrIdx="index" 
            v-for="(item, index) in drawList" :key="item.index"
            :type="item.type" :other="item" :tiScore="item.score" :eColor="item.color" 
            :isDraggable="item.isD" :isResizable="item.isR" :caidianScore="caiDian?.myScore ?? 0" :zgInfo="selZgInfo"
            @changeScore="changeScore" @select="selectPoint" @repos="changePoint" 
            @quickScore="quickScoreSet" @deleteMe="spDeleteMe" @changeCaiDianScore="changeCaiDianScore">
          </scorePoint>
        </div>
  
        <!-- 右侧打分板 -->
        <rightPanel 
          ref="rightPanel" 
          :zgInfo="selZgInfo" 
          :visible="selZgInfo != null" 
          :showAllExam="baseSetting.showAllExam" 
          :isEdit="isEdit" 
          :selMenu="selMenu" 
          @quickScore="quickScoreAction"
          @changeMode="rpChangeMode" 
          @okExam="openViewer" 
          @submitScore="rpSubmitScore" 
          @submitNext="submitNext" 
          @reEdit="reEdit" 
          @submitScoreReCheck="rpSubmitScoreRecheck"
          @canvasClose="cancelCanvas">
        </rightPanel>
        
        <!-- √× 批阅栏 -->
        <operPanel 
          ref="operPanel" 
          :status="selZgInfo?.status" 
          :x="operInfo.x" 
          :y="operInfo.y" 
          :visible="selZgInfo != null" 
          v-if="selZgInfo != null" 
          @ok="operOK" 
          @updateOptionInfo="updateOptionInfo">
        </operPanel>
      </div>
  
      <!-- 底图 -->
      <el-row>
        <el-col :span="24">
          <el-row v-show="tableData" @click="openViewer">
            <el-col :span="24">
              <canvas id="myCanvas1" width="1000" height="1000"></canvas>
            </el-col>
          </el-row>
          <el-row v-show="tableData" @click="openViewer">
            <el-col :span="24">
              <canvas id="myCanvas2" width="1000" height="1000"></canvas>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </template>
  
  <script>
  import * as mUtils from '@/utils/mUtils'
  import { mapState } from 'vuex'
  import * as simpleApi from "request/simple";
  import rightPanel from "./rightPanel";
  import operPanel from "./operPanel";
  import scorePoint from "./scorePoint";
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
  import XEUtils from "xe-utils";
  import { suoXiao } from "../../../utils/mUtils";
  import key from 'keymaster'
  
  export default {
    name: 'rightPage',
    components: {
      ElImageViewer, rightPanel, operPanel, scorePoint
    },
    props: {
      info: {
        type: Object
      },
      teacherId: {
        type: String
      },
      examId: {
        type: [Number, String],
        default: null
      },
      percentType:Boolean,
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo,
      })
    },
    watch: {
      info: {
        deep: true, immediate: true,
        handler(n) {
          if (n) {
            this.cancelCanvas()
            this.scanPre = n;
            this.examIdVal = n.exam_id;
            this.loadExamInfoAndData();
          }
        }
      },
      drawMode: {
          deep: true, immediate:true,
          handler(n, o){
              // console.log('drawMode change', n);
              let that = this;
              if(n ==8){ //重置所有数据

                  this.examImageList = [];
                  this.selPoint = null;
                  if(this.scanPreResult != null){
                      if(this.scanPreResult.oss_full_name1 != null)this.examImageList.push(this.scanPreResult.oss_full_name1);
                      if(this.scanPreResult.oss_full_name2 != null) this.examImageList.push(this.scanPreResult.oss_full_name2);
                  }
                  if(this.isQuickScore){
                    for (let i=this.drawList.length-1; i>=0; i--){
                      let w = this.drawList[i];
                      if(w.type == 100){
                        // 清空分数的同时清空pointList(踩点记录)
                        w.score = 0;
                        w.pointList = []
                      }
                      else this.drawList.splice(i, 1)
                    }
                  }else{
                    this.drawList = [];
                  }
                  this.$refs.rightPanel.clearScore();
                  this.drawMode = -1;


                  
              }
              if(n == 9 || n == 10){
                  this.examImageList = [];
                  this.drawList = [];
                  if(this.zgForm.limit == null) {
                      this.zgForm.limit = 0;
                  } else{
                      // console.log(this.zgForm.limit, this.zgForm.idxCount)
                      if(n == 10) this.zgForm.limit = this.zgForm.limit + this.zgForm.idxCount;
                      if(n == 9 && this.zgForm.limit > 0) this.zgForm.limit = this.zgForm.limit - this.zgForm.idxCount;
                  }
                  this.loadZgExam();
                  this.drawMode = -1;
              }
              if(n ==5){ //删除标记
                  let that = this;
                  if(this.selPointIndex>-1){
                      let selPoint = this.drawList[this.selPointIndex];
                      // console.log('del', this.selPointIndex, selPoint.showX, selPoint.showY);
                      if(selPoint.type == 99){
                          // console.log('del selPoint', selPoint);
                          this.$refs.rightPanel.caidianScore(selPoint.topicIndex, 0-selPoint.score, false, true);
                      }
                      if(selPoint.type == 100){selPoint.score = 0; this.$refs.rightPanel.caidianScore(selPoint.topicIndex, 0, true, true); this.drawMode = -1; return;}
                      this.loading = true;
                      let myList = Object.assign(this.drawList);
                      myList.splice(this.selPointIndex, 1);
                      this.drawList = [];
                      setTimeout(function () {
                          that.drawList = myList;
                          // that.drawList.forEach((item, index) => {console.log(index, item.showX, item.showY)});
                        that.loading = false;
                      }, 800);
                  }
                  this.drawMode = -1;
              }
              if(n > 0 && "rightPanel" in this.$refs && this.$refs.rightPanel != null){
                  if(n != 99) this.$refs.rightPanel.makeTopicValue(null);
              }
          }
      },
    },
    data() {
      return {
        // 原始数据
        scanPre: null,
        scanList: [],
        tableData: null,
        examIdVal: null,
        studentId: null,
        
        // 试卷图片
        examImageList: [],
        showViewer: false,
        
        // 客观题相关
        kgScore: 0,
        kgData: null,
        kgList: [],
        
        // 主观题相关
        zgScore: 0,
        zgList: [],
        showZgList: [],
        drawZgList: [],
        examSeqList: [],
        idCountList: {},
        
        // 当前选中的主观题信息
        selZgInfo: null,
        zgData: [],
        drawList: [],
        selPoint: null,
        selPointIndex: -1,
        selMenu: null,
        
        // 右侧面板相关
        isEdit: false,
        baseSetting: { showStudentInfo: false, showAllExam: false, showKg: false },
        
        // 画布相关
        myCanvas: null,
        ctx: null,
        imgScale: 0.5,
        imgList: [],
        canvasWidth: 1000,
        canvasHeight: 1000,
        scale: 1,
        
        // 批阅模式
        drawMode: -1,
        caiDian: {
          topicIndex: null,
          myScore: null,
          step: 1
        },
        
        // 快捷打分
        isQuickScore: false,
        topicData: [],
        topicType: null,
        fillBlankList: [],
        
        // 工具栏位置
        operInfo: { x: 0, y: 500 },
        
        // 点击区域
        myCanvas1List: [],
        myCanvas2List: [],
        
        // 是否显示主观题窗口
        showZg: false,
        
        // 加载状态
        loading: false,
        
        // 考试信息
        examInfo: {},
        rules: null,
        
        // 分页相关
        searchForm: {
          pageNo: 1,
          pageSize: 50,
          totalCount: 0,
          searchText: null
        },
        naturalW: 1500,
        naturalH: 800
      }
    },
    mounted() {
      let myHeight = document.documentElement.clientHeight;
      this.canvasWidth = myHeight - 200;
      this.canvasHeight = myHeight - 300;
      
      // 预设 operInfo 位置
      this.operInfo = {
        x: Math.round(window.innerWidth * 0.5),
        y: Math.round(window.innerHeight * 0.8)
      };
      
      // 键盘快捷键
      key('s', () => { this.keyS() });
      key('w', () => { this.keyW() });
    },
    beforeDestroy() {
      key.deleteScope('s');
      key.deleteScope('w');
    },
    methods: {
      // ==================== 初始化和加载数据 ====================
      async loadExamInfoAndData() {
        if (this.examIdVal) {
          await this.loadExam();
          await this.getIdxCountByExamSeq();
          await this.loadKgOne();
          await this.loadZgList();
          await this.loadExamPages();
        }
      },
      
      loadExam() {
        let param = { controllerName: 'akExam', methodName: '/get', param: { id: parseInt(this.examIdVal) } };
        return simpleApi.list(param).then(({ result: { code, data } }) => {
          if (code == 0) {
            this.examInfo = data;
            if (data && data.rules != null) {
              this.rules = JSON.parse(data.rules);
              this.baseSetting = this.rules.baseSetting || { showStudentInfo: false, showAllExam: false, showKg: false };
            }
          }
        });
      },
      
      getIdxCountByExamSeq() {
        let search = { examId: this.examIdVal };
        let param = { controllerName: 'examTask', methodName: '/selectTeacherZgSeq', param: search };
        return simpleApi.list(param).then(({ result: { code, data } }) => {
          let idCountList = {};
          (data || []).forEach(item => {
            let examSeq = item.exam_seq;
            let idCount = item.all_cou / item.cou;
            idCountList[examSeq] = idCount;
          });
          this.idCountList = idCountList;
        });
      },
      
      loadKgOne() {
        let studentId = this.scanPre?.student_id || this.studentId;
        let search = { licenceId: this.userInfo.licenceId, studentId: studentId, examId: this.examIdVal };
        let param = { controllerName: 'exam/kg', methodName: '/byStudentId', param: search };
        return simpleApi.post(param).then(({ result: { code, data } }) => {
          this.kgData = data;
          this.kgList = [];
          if (code == 0 && data != null) {
            this.kgId = data.id;
            if (data.answerText && data.answerText != null) {
              let kg = JSON.parse(data.answerText);
              if (kg.list) {
                this.kgList = kg.list;
                this.kgList = XEUtils.sortBy(this.kgList, ['num']);
              }
            }
          }
        });
      },
      
      loadZgList() {
        // 清空主客观分数
        this.kgScore = 0;
        this.zgScore = 0;
        let studentId = this.scanPre?.student_id || this.studentId;
        let search = {
          licenceId: this.userInfo.licenceId,
          studentId: studentId,
          examId: this.examIdVal,
          orderBy: 'zg.exam_seq, zg.page_no, zg.exam_index',
          isDraw: 1
        };
        let param = { controllerName: 'exam/zg', methodName: '/list', param: search, pageNo: 1, pageSize: 300 };
        return simpleApi.post(param).then(({ result: { code, data } }) => {
          this.zgList = [];
          this.showZgList = [];
          if (data && data != null) {
            this.zgList = data.result || [];
            for (let i = 0; i < this.zgList.length; i++) {
              let d = this.zgList[i];
              let fd = XEUtils.find(this.showZgList, item => item.exam_seq == d.exam_seq);
              if (!fd) this.showZgList.push(d);
            }
            this.showZgList = this.showZgList.sort((a, b) => {
              let seqA = a.exam_seq, seqB = b.exam_seq;
              let arrA = seqA.split(","), arrB = seqB.split(",");
              let vA = 0, vB = 0;
              if (arrA.length > 1) vA = parseInt(arrA[0]); else vA = parseInt(seqA);
              if (arrB.length > 1) vB = parseInt(arrB[0]); else vB = parseInt(seqB);
              return vA - vB;
            });
          }
        });
      },
      
      loadExamPages() {
        // 清空绘图记录缓存，确保重新加载时能正确绘制
        this.drawZgList = [];
        this.drawList = [];

        let search = { licenceId: this.userInfo.licenceId, id: this.scanPre.id};
        let param = { controllerName: 'scan/scanPreResult', methodName: '/getById',  param: search};
        
        return simpleApi.list(param).then(({ result: { code, data } }) => {

            let scanPreResult = data;
            this.tableData = scanPreResult;
            this.studentId = scanPreResult.studentId;
            
            this.examImageList = [];
            if (scanPreResult.ossFullName1 != null) {
              this.tableData.ossFullName1 = mUtils.urlAddTimestamp(mUtils.changeSpecialCode(scanPreResult.ossName1, scanPreResult.ossFullName1));
              this.examImageList.push(scanPreResult.ossFullName1);
            }
            if (scanPreResult.ossFullName2 != null) {
              this.tableData.ossFullName2 = mUtils.urlAddTimestamp(mUtils.changeSpecialCode(scanPreResult.ossName2, scanPreResult.ossFullName2));
              this.examImageList.push(scanPreResult.ossFullName2);
            }
            

            // 先获取老师批阅的题号列表，再加载 canvas
            this.getExamSeqByExamIdAndTeacherId().then(() => {
                this.loadCanvas(scanPreResult, 1, () => {
                if (scanPreResult.cutOssFullName2 != null) {
                    this.loadCanvas(scanPreResult, 2);
                }
                });
            });

         
        });
      },
      
      // ==================== Canvas 绘制 ====================
      loadCanvas(d, pageNo, callback) {
        this.$nextTick(() => {
          let canvas = document.getElementById("myCanvas" + pageNo);
          if (!canvas || !canvas.getContext) return;
          
          let ctx = canvas.getContext('2d');
          ctx.font = 'normal 10px Arial,sans-serif';
          
          let img = new Image();
          let url = mUtils.urlAddTimestamp(mUtils.changeSpecialCode(d["cutOssName" + pageNo], d["cutOssFullName" + pageNo]));
          img.src = url;
          img.crossOrigin = "Anonymous";
          
          let tt = document.documentElement.clientWidth / 5 * 3;
          
          img.onload = () => {
            this.naturalW = img.naturalWidth;
            this.naturalH = img.naturalHeight;
            
            let scale = 1;
            if (img.width > tt || img.height > tt) {
              if (img.width > img.height) scale = tt / img.width;
              if (img.height > img.width) scale = tt / img.height;
            }
            
            ctx.width = img.width * scale;
            ctx.height = img.height * scale;
            canvas.width = ctx.width;
            canvas.height = ctx.height;
            ctx.drawImage(img, 0, 0, ctx.width, ctx.height);
            
            this.cardInfoAndImage(ctx, d, pageNo, scale);
            if (callback) callback();
          };
        });
      },
      // 绘制标识
      cardInfoAndImage(ctx, d, pageNo, scale) {
        // debugger
        if (pageNo == 1) {
          this.myCanvas1List = [];
        } else {
          this.myCanvas2List = [];
        }
        
        let cutType = d.cutType;
        let width = ctx.width;
        let height = ctx.height;
        
        ctx.fillStyle = 'red';
        ctx.strokeStyle = 'red';
        
        if (d.cardInfo) {
          let cardInfo = JSON.parse(d.cardInfo);
          if (cardInfo && cardInfo.length > 0) {
            let sections = cardInfo[pageNo - 1]?.sections || [];
            
            for (let i = 0; i < sections.length; i++) {
              let sect = sections[i];
              let list = sect.list || [];
              
              for (let j = 0; j < list.length; j++) {
                let item = list[j];
                
                if (item.type == "studentNo") {
                  this.drawStudentNo(ctx, item, d, width, height, cutType, pageNo);
                } else if (item.type == "Object") {
                  debugger
                  this.drawObjective(ctx, item, d, width, height, cutType);
                } else {
                  this.drawSubjective(ctx, item, d, pageNo, width, height, cutType);
                }
              }
            }
          }
        }
        
        this.$nextTick(() => {
          this.bindCanvasClick(pageNo);
        });
      },
      
      drawStudentNo(ctx, item, d, width, height, cutType, pageNo) {
        let pos = item.position;
        let w = pos.width_scale * width;
        let h = pos.height_scale * height;
        let x = pos.left_begin * width;
        let y = pos.top_begin * height;
        
        if (cutType == 1) {
          let naturalH = this.naturalH;
          let naturalW = this.naturalW;
          let width_sc = naturalW / width;
          let height_sc = naturalH / height;
          x = pos.left / width_sc;
          y = pos.top / height_sc;
          w = pos.width / width_sc;
          h = pos.height / height_sc;
        }
        
        if (this.kgData && this.kgData.status == 'ZB') {
          ctx.font = 'normal bold 56px Arial,sans-serif';
          ctx.fillText('作弊', width / 2 - 100, height / 2 - 40);
          ctx.font = 'normal 10px Arial,sans-serif';
        }
        
        if ("numList" in item) {
          ctx.fillStyle = 'red';
          let numList = item.numList;
          let numW = w / numList.length;
          for (let n = 0; n < numList.length; n++) {
            ctx.fillText(numList[n], x + 5 + numW * n, y + h + 10);
          }
          ctx.strokeRect(x, y, w, h);
        } else {
          ctx.fillStyle = 'blue';
          ctx.fillText(d.studentNo, x + 5, y + h + 25);
          ctx.fillStyle = 'red';
        }
        
        this.scaleScore(ctx, x, y, w, h);
      },
      // 绘制客观题
      drawObjective(ctx, item, d, width, height, cutType) {
        // debugger
        ctx.fillStyle = '#409eff';

        let pos = item.position;
        let branchs = item.branch;
        
        let naturalH = this.naturalH;
        let naturalW = this.naturalW;
        let width_sc = naturalW / width;
        let height_sc = naturalH / height;
        let width_scntron = pos.width / pos.scantron_width;
        let height_scntron = pos.height / pos.scantron_height;
        let left_start = pos.left / width_sc;
        let top_start = pos.top / height_sc;
        
        for (let k = 0; k < branchs.length; k++) {
          let branch = branchs[k];
          ctx.lineWidth = 1;
          
          let posWidth = pos.width_scale * width;
          let posHeight = pos.height_scale * height;
          let x = pos.left_begin * width + posWidth * branch.left_begin;
          let y = pos.top_begin * height + posHeight * branch.top_begin;
          let w = posWidth * branch.width_ratio;
          let h = posHeight * branch.height_ratio;
          
          if (cutType == 1) {
            let pos_cut = branch.position;
            x = pos_cut.left / width_sc * width_scntron + left_start;
            y = pos_cut.top / height_sc * height_scntron + top_start;
            w = pos_cut.width / width_sc * width_scntron;
            h = pos_cut.height / height_sc * height_scntron;
          }
          
          if ("stu_answer" in branch) {
            ctx.font = 'bold 16px Arial,sans-serif';
            
            let stu_anw = branch.stu_answer;
            let numList = branch.ixList;
            let a_h = h / stu_anw.length;
            
            for (let m = 0; m < stu_anw.length; m++) {
              let topic_index = numList[m];
              let anw_ = this.kgList.filter(item => item.num == topic_index);
              let char = "×";
              if (anw_.length > 0 && anw_[0].userScore != 0) {
                ctx.font = 'normal 16px Arial,sans-serif';
                char = "✔";
              }
              
              let a_x = x + 10;
              let a_y = y + 15 + m * a_h;
              ctx.fillText(char, a_x, a_y);
            }
          }
          ctx.strokeStyle = '#409eff';
          ctx.strokeRect(x, y, w, h);
        }
        
        if (cutType == 1) {
          this.drawChooseByCut(ctx, height, width, pos, branchs);
        } else {
          this.drawChoose(ctx, height, width, pos, branchs);
        }

        ctx.strokeStyle = 'red';
        ctx.fillStyle = 'red';
      },
      // 绘制主观题
      drawSubjective(ctx, item, d, pageNo, width, height, cutType) {
        // debugger
        let pos = item.position;
        let w = pos.width_scale * width;
        let h = pos.height_scale * height;
        let x = pos.left_begin * width;
        let y = pos.top_begin * height;
        
        if (cutType == 1) {
          let naturalH = this.naturalH;
          let naturalW = this.naturalW;
          let width_sc = naturalW / width;
          let height_sc = naturalH / height;
          x = pos.left / width_sc;
          y = pos.top / height_sc;
          w = pos.width / width_sc;
          h = pos.height / height_sc;
        }
        
        let examSeqList = [];

        // debugger
        if ("branch" in item) {
          let branchs = item.branch;
          // examSeqList = 
          this.drawZgScore(ctx, branchs, 1, pageNo, x, y, w, h);
        }
        
        // 过滤下整个题块的题号 检查是否在老师批阅范围内
        let branchIx = item.branch
        branchIx.forEach(item =>{
          let ixList = item.ixList
          examSeqList.push(...ixList)
        })
        let seq = examSeqList.join(',');
        let isTeacherTopic = this.examSeqList.includes(seq);
        
        if (!isTeacherTopic) {
        //   ctx.fillStyle = 'rgba(180,180,180,0.6)';
        //   ctx.fillRect(x, y, w, h);
          ctx.strokeStyle = '#409eff'; 
          ctx.strokeRect(x, y, w, h);

        } else {
          let clickItem = { x: x, y: y, w: w, h: h, examSeq: seq };
          if (pageNo == 1) {
            this.myCanvas1List.push(clickItem);
          } else {
            this.myCanvas2List.push(clickItem);
          }
          ctx.strokeStyle = 'red'; 
          ctx.strokeRect(x, y, w, h);
        }
      },
      
      drawChoose(ctx, height, width, pos, branchs) {
        let posLeft = pos.left_begin * width;
        let posTop = pos.top_begin * height;
        let posWidth = pos.width_scale * width;
        let posHeight = pos.height_scale * height;
        
        for (let i = 0; i < branchs.length; i++) {
          let branch = branchs[i];
          let b_t = posHeight * branch.top_begin + posTop;
          let b_l = posWidth * branch.left_begin + posLeft;
          let b_h = posHeight * branch.height_ratio;
          let b_w = posWidth * branch.width_ratio;
          let perPre = (branch.subAreaTopicType == "Judge") ? "PD" : "P";
          let ixList = branch.ixList;
          let ixY = b_t + b_h * 2.5 / pos.height;
          let tiH = b_h * 5 / pos.height;

          // 获取比例 （比例换算版本 或 等分距离版本）
          let percent_ = mUtils.getPercent(this.percentType)
          let percent = percent_[perPre + branch.chooseCount];

          // let percent = this.percent[perPre + branch.chooseCount];
          
          for (let j = 0; j < ixList.length; j++) {
            let iY = ixY + j * tiH;
            for (let k = 0; k < percent.length; k++) {
              let tiX = b_l + b_w * percent[k][0];
              let tiXEnd = b_l + b_w * percent[k][1];
              let tiW = tiXEnd - tiX;
              let tiGe = tiW / 4;
              let tiHGe = tiH / 4;
              ctx.beginPath();
              ctx.rect(tiX + tiGe, iY, tiW * 0.65, tiH - tiHGe);
              ctx.stroke();
            }
          }
        }
      },
      
      drawChooseByCut(ctx, height, width, pos, branchs) {
        let naturalH = this.naturalH;
        let naturalW = this.naturalW;
        let width_sc = naturalW / width;
        let height_sc = naturalH / height;
        let width_scntron = pos.width / pos.scantron_width;
        let height_scntron = pos.height / pos.scantron_height;
        let x_start = pos.left / width_sc;
        let y_start = pos.top / height_sc;
        let w = pos.width / width_sc;
        let h = pos.height / height_sc;
        
        branchs.forEach((ele, index) => {
          let chooseCount = ele.chooseCount;
          let position = ele.position;
          let left_start = position.left / width_sc * width_scntron + x_start;
          let top_start = position.top / height_sc * height_scntron + y_start;
          let select_width = position.width / width_sc * width_scntron;
          let select_height = position.height / height_sc * height_scntron;

          // 获取比例 （比例换算版本 或 等分距离版本）
          let percent_ = mUtils.getPercent(this.percentType)
          let percent = percent_["P" + chooseCount];
          // let percent = this.percent["P" + chooseCount];

          let ixList = ele.ixList;
          let y = height_sc * 1.5;
          let x = index == 0 ? x_start : left_start;
          
          ixList.forEach((item, idx) => {
            for (let k = 0; k < percent.length; k++) {
              let boxHeight = 5 * height_scntron / height_sc;
              let left = percent[k][0] * select_width;
              let left_end = percent[k][1] * select_width;
              let boxWidth = left_end - left;
              let top = y + boxHeight * idx;
              ctx.strokeRect(left + x, top + y_start, boxWidth * 0.85, boxHeight * 0.85);
            }
          });
        });
      },
      
      // 绘制主观题 - 题目批阅记录
      drawZgScore(ctx, branchs, scale, pageNo, x, y, w, h) {
        // debugger
        let examSeqList = [];
        ctx.font = 'normal 16px Arial,sans-serif';
        
        for (let i = 0; i < branchs.length; i++) {
          // debugger
          let branch = branchs[i];
          let ixList = branch.ixList.join(",");

          // 此老师的记录为红色 其余的为蓝色

          let isTeacherTopic = this.examSeqList.includes(ixList);
          let drawColor = isTeacherTopic ? 'red' : '#409eff';

          let numList = branch.numList.join(",");
          let z_y = y;
          let exitCount = XEUtils.filter(this.drawZgList, item => item.exam_seq == ixList);
          let blockIndex = exitCount.length;
          
          let fidx = XEUtils.findIndexOf(this.zgList, item => (item.exam_seq == ixList && item.page_no == (pageNo - 1)));
          let zg = null;
          
          if (fidx > -1) {
            let dragFind = XEUtils.find(this.drawZgList, item => item.exam_seq == ixList && item.page_no == (pageNo - 1));
            zg = this.zgList[fidx];
            if (dragFind && zg && zg.exam_index == dragFind.exam_index) {
              let f2zg = XEUtils.find(this.zgList, item => item.exam_seq == ixList && item.page_no == (pageNo - 1) && item.exam_index != dragFind.exam_index);
              if (f2zg) zg = f2zg;
            }
          }
          // debugger
          if (zg != null) {
            // debugger
            let drawidx = XEUtils.findIndexOf(this.drawZgList, item => item.id == zg.id);
            
            if (zg.mark_record != null) {
              try {
                let dimension = JSON.parse(zg.mark_record);
                let stepScores = [];
                
                if ("scoreInfo" in dimension) {
                  let scoreInfo = dimension["scoreInfo"];
                  if ("topicData" in scoreInfo) {
                    // debugger
                    let topicData = scoreInfo["topicData"];
                    if (topicData.length > 0 && drawidx < 0 && zg.drawType == 1) {
                      let ci = parseInt(h / 20) - 1;
                      for (let di = 0; di < topicData.length; di++) {
                        let dime = topicData[di];
                        z_y = z_y + 20;


                        ctx.fillStyle = drawColor;
                        
                        ctx.font = 'bold 16px "Source Han Serif CN", serif';
                        ctx.fillText('题' + dime.topicIndex + ": " + XEUtils.toNumber(dime.score) + "分", x - 10, z_y);

                        examSeqList.push(dime.topicIndex);

                        if (di > 0 && di % ci == 0) {
                          z_y = y + 15;
                        }
                      }
                    }
                  }
                  if (("setting" in scoreInfo) && ("bySteps" in scoreInfo.setting)) {
                    stepScores = scoreInfo.setting.bySteps;
                  }
                }
                
                if ("points" in dimension) {
                  let points = dimension["points"];
                  for (let di = 0; di < points.length; di++) {
                    let pnt = points[di];
                    if (drawidx > -1) {
                      let pre = this.drawZgList[drawidx];
                      let pre_dim = JSON.parse(pre.mark_record);
                      let isExist = false;
                      for (let k = 0; k < pre_dim.points.length; k++) {
                        let pp = pre_dim.points[k];
                        if (pp.x == pnt.x && pp.y == pnt.y) {
                          if ("blockIndex" in pp) {
                            if (pp.blockIndex != blockIndex) {
                              isExist = true;
                              break;
                            }
                          } else {
                            isExist = true;
                            break;
                          }
                        }
                      }
                      if (isExist) continue;
                    }
                    if (("blockIndex" in pnt) && pnt.blockIndex != blockIndex) continue;
                    
                    let iType = pnt.type;
                    let mcX = x + w * pnt.scaleX;
                    // // 因为存储时 scaleY = (clickY - 15) / height 所以还原时需要加上 15 的偏移
                    let mcY = y + h * pnt.scaleY + 15
                    
                    for (let k = 1; k < 5; k++) {
                      if (("scaleX" + k) in pnt) mcX = x + w * suoXiao(pnt["scaleX" + k]);
                      if (("scaleY" + k) in pnt) mcY = (y + 15) + h * suoXiao(pnt["scaleY" + k]);
                    }

                    
                    let pw = pnt.w * scale;
                    let ph = pnt.h * scale;
                    let endY = y + h;
                    ctx.lineWidth = 3;
                    
                    if (iType == 1) {
                      ctx.font = 'normal 16px Arial,sans-serif';
                      let pmcY = mcY + ph;
                      if (pmcY > endY) {
                        ctx.beginPath();
                        ctx.moveTo(mcX, (endY - ph) + ph * 0.7);
                        ctx.lineTo(mcX + pw * 0.3, endY);
                        ctx.lineTo(mcX + pw, (endY - ph));
                        ctx.stroke();
                      } else {
                        ctx.beginPath();
                        ctx.moveTo(mcX, mcY + ph * 0.7);
                        ctx.lineTo(mcX + pw * 0.3, mcY + ph);
                        ctx.lineTo(mcX + pw, mcY);
                        ctx.stroke();
                      }
                    }
                    if (iType == 2) {
                      ctx.font = 'normal 16px Arial,sans-serif';
                      let pmcY = mcY + ph;
                      if (pmcY > endY) {
                        ctx.beginPath();
                        ctx.moveTo(mcX, endY - ph);
                        ctx.lineTo(mcX + pw, endY);
                        ctx.moveTo(mcX, endY);
                        ctx.lineTo(mcX + pw, endY - ph);
                        ctx.stroke();
                      } else {
                        ctx.beginPath();
                        ctx.moveTo(mcX, mcY);
                        ctx.lineTo(mcX + pw, mcY + ph);
                        ctx.moveTo(mcX, mcY + ph);
                        ctx.lineTo(mcX + pw, mcY);
                        ctx.stroke();
                      }
                    }
                    if (iType == 3) {
                      ctx.font = 'normal 16px Arial,sans-serif';
                      ctx.beginPath();
                      ctx.ellipse(mcX + pw / 2, mcY + ph / 2, pw / 2, ph / 2, 0, 0, Math.PI * 2);
                      ctx.stroke();
                    }
                    if (iType == 4) {
                      ctx.font = 'bold 16px Arial, sans-serif';
                      ctx.fillText(pnt.wenziText, mcX, mcY + ph);
                    }
                    if (iType == 99) {
                      ctx.font = 'bold 18px Arial, sans-serif';
                      let iScore = "" + pnt.score;
                      if (pnt.score > 0) iScore = "+" + pnt.score;
                      if (pnt.score < 0) iScore = pnt.score;
                      ctx.fillText(iScore, mcX, mcY);
                    }
                    ctx.lineWidth = 1;
                  }
                }
                
                if (drawidx < 0) {
                  
                  ctx.fillStyle = drawColor;

                  ctx.font = 'bold 16px "Source Han Serif CN", serif';
                  let text = "批阅人：" + (zg.nick_name || "");
                  ctx.fillText(text, x + w * 0.75, y + 10);
                  
                  if (stepScores && stepScores.length > 0) {
                    let tempY = y;
                    for (let ki = 0; ki < stepScores.length; ki++) {
                      let sps = stepScores[ki];
                      tempY = tempY + 25;
                      ctx.fillText(sps.name + "：" + sps.score, x - 10, tempY);
                    }
                  }
                }
              } catch (e) {
                console.log("error", e);
              }
              this.drawZgList.push(zg);
            }
          }
        }
        return examSeqList;
      },
      scaleScore(ctx, x, y, w, h) {
        // debugger
        let that = this;
        XEUtils.arrayEach(this.kgList, (item, key) => {
          that.kgScore = that.kgScore + XEUtils.toNumber(item.userScore);
        });
        
        if (this.zgList != null && this.zgList.length > 0) {
          let trueZgs = [];
          for (let i = 0; i < this.zgList.length; i++) {
            let d = this.zgList[i];
            let tfind = XEUtils.find(trueZgs, item => item.exam_seq == d.exam_seq);
            if (!tfind) trueZgs.push(d);
          }
          XEUtils.arrayEach(trueZgs, (item, key) => {
            that.zgScore = that.zgScore + XEUtils.toNumber(item.score);
          });
        }
        
        ctx.font = 'normal bold 18px Arial,sans-serif';
        let zgScore = XEUtils.toNumber(that.zgScore).toFixed(2);
        let kgScore = XEUtils.toNumber(that.kgScore).toFixed(2);
        let content = "客观题:" + kgScore + "分";
        if (this.zgList == null || this.zgList.length > 0) {
          content = content + "， 主观题:" + zgScore + "分";
        }
        content = content + "， 总分:" + (parseFloat(kgScore) + parseFloat(zgScore)).toFixed(2) + "分";
        ctx.fillText(content, x - 80, y - 35);
      },

      scaleScore2(ctx, x, y, w, h) {

      },
      // ==================== 主观题窗口相关 ====================
      bindCanvasClick(pageNo) {
        // debugger
        let canvas = document.getElementById("myCanvas" + pageNo);
        if (!canvas) return;
        
        canvas.onclick = (e) => {
          const rect = canvas.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          let list = pageNo == 1 ? this.myCanvas1List : this.myCanvas2List;
          
          list.forEach((box) => {
            if (x >= box.x && x <= box.x + box.w && y >= box.y && y <= box.y + box.h) {
              this.showZg = true;
              this.loadZgExam(box);
            }
          });
        };
      },
      // 获取该学生被分配给阅卷老师的主观题题号
      async  getExamSeqByExamIdAndTeacherId(){
        let studentId = this.scanPre.student_id
        let examId = this.scanPre.exam_id
        let search = {
          examId: examId,
          studentId: studentId,
          teacherId: this.teacherId
        }
        let param = { controllerName: 'exam/zg', methodName: '/getExamSeqByExamIdAndTeacherId',  param: search};
        return simpleApi.list(param).then(({result: {code, data}}) =>  {
          let list = data.map(item => item.exam_seq)
          this.examSeqList = list
        })
      },
      
      loadZgExam(value) {
        // debugger
        this.loading = true;
        let params = {
          examId: this.examIdVal,
          studentId: this.studentId,
          examSeq: value.examSeq,
          idxCount: this.idCountList[value.examSeq] || 2
        };
        let param = { controllerName: 'examTask', methodName: '/getZgList', param: params };
        this.zgData = [];
        
        simpleApi.list(param).then(({ result: { code, data } }) => {
          // debugger
          if (code == 0 && data && data.length > 0) {
            let first = data[0];
            this.selZgInfo = {
              examId: first.exam_id,
              examSeq: first.exam_seq,
              studentId: first.student_id,
              scanFileId: first.scan_file_id,
              studentNo: first.student_no,
              studentName: first.student_name,
              kgScore: first.kg_score,
              zgIds: [first.id],
              teacherId: first.teacher_id,
              isQuickScore: first.isQuickScore,
              markRecords: [first.mark_record],
              drawImgs: [first.draw_img],
              status: first.status,
              abPaper: first.ab_paper,
              seqAverageScore: null,
              examScoreType: null,
              isCheck: true
            };
            
            if (data.length == 1) {
              this.zgData = data;
            } else {
              this.zgData = [];
              this.selZgInfo.zgIds = [];
              this.selZgInfo.markRecords = [];
              this.selZgInfo.drawImgs = [];
              for (let i = 0; i < data.length; i++) {
                let ed = data[i];
                if (first.student_id == ed.student_id) {
                  this.zgData.push(ed);
                  this.selZgInfo.zgIds.push(ed.id);
                  this.selZgInfo.markRecords.push(ed.mark_record);
                  this.selZgInfo.drawImgs.push(ed.draw_img);
                }
              }
            }
            
            this.loadCanvasZg();
            this.loadFullExam();
            this.getAverageScore();
          }
          this.loading = false;
        }).catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
      },
      
      loadCanvasZg() {
        let that = this;
        this.imgList = [];
        this.drawList = [];
        
        this.$nextTick(() => {
          if (that.zgData == null || that.zgData.length < 1) return;
          let canvas = document.getElementById("myCanvas3");
          if (!canvas || !canvas.getContext) return;
          
          this.myCanvas = canvas;
          let ctx = canvas.getContext('2d');
          this.ctx = ctx;
          this.ctx.scale(this.scale, this.scale);
          
          let myCount = 0;
          for (let i = 0; i < that.zgData.length; i++) {
            let ed = that.zgData[i];
            let img = new Image();
            img.crossOrigin = "Anonymous";
            img.src = mUtils.urlAddTimestamp(window.g.OSS_HOST + ed.oss_name);
            that.imgList.push({ img: img, width: 0, height: 0 });
            
            img.onload = function() {
              that.imgList[i].width = this.width * that.scale;
              that.imgList[i].height = this.height * that.scale;
              if (that.zgData.length == (myCount + 1)) {
                that.drawImage(i);
              } else {
                myCount = myCount + 1;
              }
            };
          }
        });
      },
      
      drawImage(imgIndex, setScale) {
        let myWidth = 0, myHeight = 0;
        for (let i = 0; i < this.imgList.length; i++) {
          let myImg = this.imgList[i];
          myWidth = myImg.width;
          myHeight = myHeight + myImg.height;
        }
        
        if (!setScale) {
          let scale = 1;
          if (myWidth > this.canvasWidth) {
            scale = this.canvasWidth / myWidth;
            this.ctx.width = myWidth * scale;
            this.ctx.height = myHeight * scale;
            this.imgScale = scale;
          } else {
            this.ctx.width = myWidth;
            this.ctx.height = myHeight;
          }
          
          this.myCanvas.width = this.ctx.width;
          this.myCanvas.height = this.ctx.height;
          
          let dy = 0;
          for (let i = 0; i < this.imgList.length; i++) {
            let myImg = this.imgList[i];
            let imgWidth = myImg.width * scale;
            let imgHeight = myImg.height * scale;
            this.ctx.drawImage(myImg.img, 0, dy, imgWidth, imgHeight);
            this.selZgInfo["zg" + (i + 1)] = { x: 0, y: dy, width: imgWidth, height: imgHeight };
            dy = dy + imgHeight;
          }
        }
        
        setTimeout(() => {
          this.loadMarkRecord(imgIndex, () => {
            this.loading = false;
          });
        }, 500);
      },
      
      loadMarkRecord2(imgIndex, callback) {
        if (this.selZgInfo.status == 'YY') {
          let markRecords = this.selZgInfo.markRecords;
          if (markRecords != null && markRecords.length > 0) {
            for (let i = 0; i < markRecords.length; i++) {
              if (markRecords[i] != null) {
                let mrjson = JSON.parse(markRecords[i]);
                let rect = this.myCanvas.getBoundingClientRect();
                let canWidth = rect.width;
                let canHeight = rect.height;
                
                if ("points" in mrjson && mrjson.points.length > 0) {
                  for (let j = 0; j < mrjson.points.length; j++) {
                    let m = mrjson.points[j];
                    let showX = m.scaleX * canWidth;
                    // let showY = m.scaleY * canHeight;
                    // 遮罩层显示时也需要加上 25 的偏移
                    let showY = m.scaleY * canHeight + 25;
                    
                    let o = Object.assign(m, { showX: showX, showY: showY });
                    if (m.type == 4 && "wenziText" in m) {
                      let pw = m.wenziText.length * 20;
                      o.w = 40 + pw;
                    }
                    
                    let isExist = false;
                    for (let k = 0; k < this.drawList.length; k++) {
                      let dl = this.drawList[k];
                      if (dl.x == o.x && dl.y == o.y) {
                        isExist = true;
                        break;
                      }
                    }
                    if (!isExist) {
                      this.drawList.push(o);
                    }
                  }
                }
              }
            }
          }
        }
        if (callback) callback();
      },
      loadMarkRecord(imgIndex, callback) {
        if (this.selZgInfo.status == 'YY') {
            let markRecords = this.selZgInfo.markRecords;
            if (markRecords != null && markRecords.length > 0) {
            for (let i = 0; i < markRecords.length; i++) {
                if (markRecords[i] != null) {
                let mrjson = JSON.parse(markRecords[i]);
                let rect = this.myCanvas.getBoundingClientRect();
                let canWidth = rect.width;
                let canHeight = rect.height;
                
                if ("points" in mrjson && mrjson.points.length > 0) {
                    for (let j = 0; j < mrjson.points.length; j++) {
                    let m = mrjson.points[j];
                    
                    // 计算实际位置（不偏移，直接给 vue-drag-resize 使用）
                    let realX = m.scaleX * canWidth;
                    // 这个 +2 是遮罩层显示会稍微偏上 调整下与底图位置一致 仅显示调整保存时位置是一致的
                    let realY = m.scaleY * canHeight + 25 + 8;
                    
                    let o = Object.assign({}, m, { 
                        x: realX,
                        y: realY,
                        // vue-drag-resize 使用 x, y 作为位置，showX/showY 这里不用了
                        showX: realX,
                        showY: realY,
                        scaleX: m.scaleX,
                        scaleY: m.scaleY
                    });
                    
                    if (m.type == 4 && "wenziText" in m) {
                        let pw = m.wenziText.length * 20;
                        o.w = 40 + pw;
                    }
                    
                    let isExist = false;
                    for (let k = 0; k < this.drawList.length; k++) {
                        let dl = this.drawList[k];
                        if (Math.abs(dl.x - o.x) < 5 && Math.abs(dl.y - o.y) < 5) {
                        isExist = true;
                        break;
                        }
                    }
                    if (!isExist) {
                        this.drawList.push(o);
                    }
                    }
                }
                }
            }
            }
        }
        if (callback) callback();
      },
      loadFullExam() {
        if (this.baseSetting.showAllExam) {
          let search = { licenceId: this.userInfo.licenceId, examId: this.selZgInfo.examId, studentId: this.selZgInfo.studentId };
          let param = { controllerName: 'scan/scanPreResult', methodName: '/list', param: search };
          simpleApi.list(param).then(({ result: { code, data } }) => {
            if (data && data.result && data.result.length > 0) {
              let scanPreResult = data.result[0];
              this.scanPreResult = scanPreResult;
              if (scanPreResult.oss_full_name1 != null) {
                this.examImageList.push(scanPreResult.oss_full_name1);
              }
              if (scanPreResult.oss_full_name2 != null) {
                this.examImageList.push(scanPreResult.oss_full_name2);
              }
            }
          });
        }
      },
      
      getAverageScore() {
        let search = { examId: this.examIdVal, examSeq: this.selZgInfo?.examSeq, teacherId: this.userInfo.id, status: "YY" };
        let param = { controllerName: 'examTask', methodName: '/getTeacherSeQAverageScore', param: search };
        simpleApi.post(param).then(({ result: { code, data } }) => {
          if (data && this.selZgInfo) {
            this.selZgInfo.seqAverageScore = data.seqAverageScore;
          }
        });
      },
      
      cancelCanvas() {
        this.showZg = false;
        this.drawList = [];
        this.selZgInfo = null;
      },
      
      // ==================== 批阅操作 ====================
    //   偏上
      canvasClick2(e) {
        if (this.drawMode <= 0) return;
        
        const rect = this.myCanvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        // 修正 Y 轴偏移（底图偏下的问题）
        const scaleX = x / rect.width;
        const scaleY = (y - 25) / rect.height;
        
        let o = {
          index: this.drawList.length,
          w: 40,
          h: 40,
          x: x,
          y: y,
          scaleX: scaleX,
          scaleY: scaleY,
          showX: x - 5,
          showY: y + 20,
          type: this.drawMode,
          isR: false,
          isD: true,
          move: true
        };
        
        if (this.isEdit) {
          if (this.userInfo.id == this.selZgInfo?.teacherId) {
            o.power = 1;
            o.color = 'darkred';
          } else {
            o.power = 2;
            o.color = 'indianred';
          }
        }
        
        if (this.drawMode == 3 || this.drawMode == 4 || this.drawMode == 14) {
          o.w = 80;
          o.isR = true;
        }
        if (this.drawMode == 12) {
          o.h = 5;
          o.w = 100;
          o.isR = true;
        }
        
        if (this.drawMode == 99) {
          if ((!XEUtils.isNumber(this.caiDian?.myScore)) || this.isQuickScore) return;
          o.score = this.caiDian.myScore;
          o.topicIndex = this.caiDian.topicIndex;
          o.scoreStep = this.caiDian.step;
          let isSuccess = this.$refs.rightPanel?.caidianScore(this.caiDian.topicIndex, this.caiDian.myScore);
          if (!isSuccess) {
            this.$message({ message: '点击分数不能超过满分或小于0分！', type: 'error', duration: 2000 });
            return;
          }
        }
        
        this.drawList.push(o);
        if (this.drawMode == 4) {
          this.drawMode = -1;
          this.$refs.operPanel?.unSelAll();
        }
        this.selPointIndex = -1;
      },
      // 画布点击事件（点击）- 遮罩层上添加批注
      // 画布点击事件（点击）- 遮罩层上添加批注
      canvasClick3(e) {
        if (this.drawMode <= 0) return;
        
        const rect = this.myCanvas.getBoundingClientRect();
        // 获取点击在 canvas 内的实际像素坐标
        let clickX = e.clientX - rect.left;
        let clickY = e.clientY - rect.top;
        
        // 边界检查
        if (clickX < 0 || clickX > rect.width || clickY < 0 || clickY > rect.height) {
            return;
        }
        
        // 计算比例
        const scaleX = clickX / rect.width;
        // 存储时需要减去 25 的偏移，这样底图绘制时加上 25 就能还原
        const scaleY = (clickY - 25) / rect.height;
        
        let o = {
            index: this.drawList.length,
            w: 40,
            h: 40,
            x: clickX,
            y: clickY,
            scaleX: scaleX,
            scaleY: scaleY,
            // vue-drag-resize 使用 x, y 作为位置，showX/showY 保持一致
            showX: clickX,
            showY: clickY,
            type: this.drawMode,
            isR: false,
            isD: true,
            move: true
        };
        
        if (this.isEdit) {
            if (this.userInfo.id == this.selZgInfo?.teacherId) {
            o.power = 1;
            o.color = 'darkred';
            } else {
            o.power = 2;
            o.color = 'indianred';
            }
        }
        
        if (this.drawMode == 3 || this.drawMode == 4 || this.drawMode == 14) {
            o.w = 80;
            o.isR = true;
        }
        if (this.drawMode == 12) {
            o.h = 5;
            o.w = 100;
            o.isR = true;
        }
        
        if (this.drawMode == 99) {
            if ((!XEUtils.isNumber(this.caiDian?.myScore)) || this.isQuickScore) return;
            o.score = this.caiDian.myScore;
            o.topicIndex = this.caiDian.topicIndex;
            o.scoreStep = this.caiDian.step;
            let isSuccess = this.$refs.rightPanel?.caidianScore(this.caiDian.topicIndex, this.caiDian.myScore);
            if (!isSuccess) {
            this.$message({ message: '点击分数不能超过满分或小于0分！', type: 'error', duration: 2000 });
            return;
            }
        }
        
        this.drawList.push(o);
        if (this.drawMode == 4) {
            this.drawMode = -1;
            this.$refs.operPanel?.unSelAll();
        }
        this.selPointIndex = -1;
        },
      // 画布点击事件（点击）- 遮罩层上添加批注 偏下
      canvasClick(e) {
        if (this.drawMode <= 0) return;
    
        const rect = this.myCanvas.getBoundingClientRect();
        let clickX = e.clientX - rect.left;
        let clickY = e.clientY - rect.top;
    
        if (clickX < 0 || clickX > rect.width || clickY < 0 || clickY > rect.height) {
            return;
        }
    
        // 图标的居中点击 - 视觉调整
        const displayOffsetX = 10;   // 向左偏移
        const displayOffsetY = 28;   // 向下偏移
        
        // 计算显示位置
        let displayX = clickX - displayOffsetX;
        let displayY = clickY + displayOffsetY;
    
        // X轴复原稍微有点偏移 
        const scaleX = (displayX  + 1) / rect.width;
        //   const scaleY = (displayY - 25) / rect.height;
        //   const scaleY = (displayY - 15) / rect.height ;
        //  底图绘制时会加 25，所以存储时要减去 25  然后 drawZgScore 中mcY 被加 + 15  也要减掉
        const scaleY = (displayY - 25 - 15 ) / rect.height ;

        let o = {
            index: this.drawList.length,
            w: 40,
            h: 40,
            x: displayX,
            y: displayY,
            scaleX: scaleX,
            scaleY: scaleY,
            showX: displayX,
            showY: displayY,
            type: this.drawMode,
            isR: false,
            isD: true,
            move: true
        };

        if (this.isEdit) {
            if (this.userInfo.id == this.selZgInfo?.teacherId) {
            o.power = 1;
            o.color = 'darkred';
            } else {
            o.power = 2;
            o.color = 'indianred';
            }
        }
            
        if (this.drawMode == 3 || this.drawMode == 4 || this.drawMode == 14) {
            o.w = 80;
            o.isR = true;
        }
        if (this.drawMode == 12) {
            o.h = 5;
            o.w = 100;
            o.isR = true;
        }
        
        if (this.drawMode == 99) {
            if ((!XEUtils.isNumber(this.caiDian?.myScore)) || this.isQuickScore) return;
            o.score = this.caiDian.myScore;
            o.topicIndex = this.caiDian.topicIndex;
            o.scoreStep = this.caiDian.step;
            let isSuccess = this.$refs.rightPanel?.caidianScore(this.caiDian.topicIndex, this.caiDian.myScore);
            if (!isSuccess) {
            this.$message({ message: '点击分数不能超过满分或小于0分！', type: 'error', duration: 2000 });
            return;
            }
        }
        
        this.drawList.push(o);
        if (this.drawMode == 4) {
            this.drawMode = -1;
            this.$refs.operPanel?.unSelAll();
        }
        this.selPointIndex = -1;
      },


      selectPoint(id, arrIdx) {
        this.selPoint = this.drawList[arrIdx];
        this.selPointIndex = arrIdx;
        if (this.isQuickScore) {
          this.$refs.rightPanel?.scoreFocusByIndex(arrIdx);
        }
      },
      //  ============ 拖拽保存批阅标记==========  
      changePoint1(id, arrIdx, newRect, wenziText) {
        let selPoint = this.drawList[arrIdx];
        this.selPointIndex = arrIdx;
        
        if (newRect != null) {
          let rect = this.myCanvas.getBoundingClientRect();
          let x = newRect.left - rect.left;
          let y = newRect.top - rect.top;
          let scaleX = x / rect.width;
          let scaleY = y / rect.height;
          
          if (scaleX < 0 || scaleX > 1) return;
          if (scaleY < 0 || scaleY > 1) return;
          
          selPoint.w = newRect.width;
          selPoint.h = newRect.height;
          selPoint.y = y;
          selPoint.x = x;
          selPoint.showX = newRect.left;
          selPoint.showY = newRect.top;
          selPoint.scaleX = scaleX;
          selPoint.scaleY = scaleY;
          selPoint.move = true;
          
          if (this.isEdit) {
            if (this.userInfo.id == this.selZgInfo?.teacherId) {
              selPoint.power = 1;
              selPoint.color = 'darkred';
            } else {
              selPoint.power = 2;
              selPoint.color = 'indianred';
            }
          }
        }
        
        if (wenziText != null) {
          selPoint.wenziText = wenziText;
          let pw = wenziText.length * 25;
          if (pw > selPoint.w) selPoint.w = pw;
        }
      },
      changePoint(id, arrIdx, newRect, wenziText) {
            let selPoint = this.drawList[arrIdx];
            this.selPointIndex = arrIdx;
  
            if (newRect != null) {
                let rect = this.myCanvas.getBoundingClientRect();
    
            // 获取显示位置
            let displayX = newRect.left;
            let displayY = newRect.top;
            
            //  canvasClick 存储公式保持一致减去 40(但是有点向上 稍微少减一点)
            let scaleX = displayX / rect.width;
            let scaleY = (displayY - 38) / rect.height; 
            
            // 边界检查
            if (scaleX < 0 || scaleX > 1) return;
            if (scaleY < 0 || scaleY > 1) return;
            
            selPoint.w = newRect.width;
            selPoint.h = newRect.height;
            selPoint.x = displayX;
            selPoint.y = displayY;
            selPoint.showX = displayX;
            selPoint.showY = displayY;
            selPoint.scaleX = scaleX;
            selPoint.scaleY = scaleY;
            selPoint.move = true;
            
            if (this.isEdit) {
            if (this.userInfo.id == this.selZgInfo?.teacherId) {
                selPoint.power = 1;
                selPoint.color = 'darkred';
            } else {
                selPoint.power = 2;
                selPoint.color = 'indianred';
            }
            }
        }
  
        if (wenziText != null) {
            selPoint.wenziText = wenziText;
            let pw = wenziText.length * 25;
            if (pw > selPoint.w) selPoint.w = pw;
        }
      },
      changeScore(id, arrIdx, tiScore, tiStep) {
        let selPoint = this.drawList[arrIdx];
        this.selPointIndex = arrIdx;
        selPoint.score = tiScore;
        this.$refs.rightPanel?.caidianScore(selPoint.topicIndex, tiStep);
      },
      
      quickScoreSet(id, arrIdx) {
        let selPoint = this.drawList[arrIdx];
        this.selPointIndex = arrIdx;
        if (this.drawMode == 99 && this.caiDian && XEUtils.isNumber(this.caiDian.myScore)) {
          if (selPoint.type !== 100) {
            let myScore = parseFloat(this.caiDian.myScore);
            selPoint.score = myScore;
            let calcScore = myScore;
            if (myScore < 0) calcScore = this.caiDian.rightScore + myScore;
            this.$refs.rightPanel?.caidianScore(selPoint.topicIndex, calcScore, true);
          }
        }
      },
      
      spDeleteMe(id, arrIdx) {
        this.selPointIndex = arrIdx;
        this.drawMode = 5;
        if (this.selPointIndex > -1) {
          let selPoint = this.drawList[this.selPointIndex];
          if (selPoint.type == 99) {
            this.$refs.rightPanel?.caidianScore(selPoint.topicIndex, 0 - selPoint.score, false, true);
          }
          if (selPoint.type == 100) {
            selPoint.score = 0;
            this.$refs.rightPanel?.caidianScore(selPoint.topicIndex, 0, true, true);
            this.drawMode = -1;
            return;
          }
          this.loading = true;
          let myList = Object.assign(this.drawList);
          myList.splice(this.selPointIndex, 1);
          setTimeout(() => {
            this.drawList = myList;
            this.loading = false;
          }, 800);
        }
        this.drawMode = -1;
      },
      
      quickScoreAction(o) {
        let { show, topicType, topicData, reset } = o;
        this.isQuickScore = show;
        this.topicType = topicType;
        this.topicData = [];
        
        if (!this.myCanvas) return;
        let rect = this.myCanvas.getBoundingClientRect();
        let canLeft = rect.left, canTop = rect.top, canWidth = rect.width, canHeight = rect.height;
        
        if (reset) {
          // 填空题打分框复原位置
          this.getFillBlankByYY(topicData, canLeft, canTop, canWidth, canHeight);
        } else {
          for (let i = this.drawList.length - 1; i >= 0; i--) {
            if (this.drawList[i].type == 100) this.drawList.splice(i, 1);
          }
          if (!show) {
            // 关闭打分面板
          } else if (topicType == 'FillBlank') {
            this.topicData = topicData;
            for (let i = 0; i < topicData.length; i++) {
              let t = topicData[i];
              let ixFind = XEUtils.find(this.fillBlankList, item => item.topicIndex == t.topicIndex);
              if (ixFind) {
                this.drawList.push(ixFind);
              } else {
                let x = canLeft + (i % 3) * 120 + 10;
                let y = canTop + parseInt(i / 3) * 40 + 5;
                let oItem = {
                  index: this.drawList.length,
                  w: 80, h: 40,
                  x: x, y: y,
                  scaleX: x, scaleY: y,
                  topicIndex: t.topicIndex,
                  showX: x, showY: y,
                  type: 100,
                  score: 0,
                  scoreStep: 0.5,
                  rightScore: t.rightScore,
                  isR: true, isD: true, move: true,
                  pointList: []
                };
                this.drawList.push(oItem);
              }
            }
          }
        }
      },
      
      getFillBlankByYY(topicData, canLeft, canTop, canWidth, canHeight) {
        this.drawList = [];
        let params = { examId: XEUtils.toNumber(this.examIdVal), examSeq: this.selZgInfo?.examSeq, limit: 1, status: 'YY' };
        let param = { controllerName: 'exam/zg', methodName: '/getFillBlankByYY', param: params };
        
        simpleApi.post(param).then(({ result: { code, data } }) => {
          if (data != null) {
            let markRecord = JSON.parse(data.markRecord);
            let point = markRecord.points;
            for (let i = 0; i < point.length; i++) {
              let o = point[i];
              o.pointList = [];
              this.drawList.push(o);
            }
          } else if (topicData) {
            for (let i = 0; i < topicData.length; i++) {
              let t = topicData[i];
              let x = canLeft + (i % 3) * 120 + 10;
              let y = canTop + parseInt(i / 3) * 40 + 5;
              let o = {
                index: this.drawList.length,
                w: 80, h: 40,
                x: x, y: y,
                scaleX: x, scaleY: y,
                topicIndex: t.topicIndex,
                showX: x, showY: y,
                type: 100,
                score: 0,
                scoreStep: 0.5,
                rightScore: t.rightScore,
                isR: true, isD: true, move: true,
                pointList: []
              };
              setTimeout(() => {
                this.drawList.push(o);
              }, 500);
            }
          }
        });
      },
      
      changeCaiDianScore(id, arrIdx, totalScore, pointList) {
        let selPoint = this.drawList[arrIdx];
        this.drawList[arrIdx].pointList = pointList;
        this.selPointIndex = arrIdx;
        let myScore = parseFloat(totalScore);
        selPoint.score = myScore;
        let calcScore = myScore;
        if (myScore < 0) calcScore = this.caiDian.rightScore + myScore;
        this.$refs.rightPanel?.caidianScore(selPoint.topicIndex, calcScore, true);
      },
      
      rpChangeMode(mode, o) {
        this.drawMode = mode;
        this.caiDian = o;
        this.$refs.operPanel?.unSelAll();
      },
      
      operOK(seq) {
        this.drawMode = seq;
      },
      
      updateOptionInfo(value) {
        this.operInfo = {
          x: value.x,
          y: value.y
        };
      },
      
      async rpSubmitScore(o) {
        let zgIds = this.selZgInfo?.zgIds;
        if (!zgIds || zgIds.length === 0) return;
        
        let menuType = false;
        let zgList = [];
        let isCd = false, cdScore = 0;
        let rect = this.myCanvas.getBoundingClientRect();
        let rectWidth = rect.width, rectHeight = rect.height;
        let beginHeight = 0, endHeight = 0;
        let zgCount = zgIds.length;
        let zgMarkList = [];
        
        for (let i = 0; i < zgCount; i++) {
          let zgId = zgIds[i];
          let zgImg = this.selZgInfo["zg" + (i + 1)];
          if (i > 0) beginHeight = endHeight;
          endHeight = endHeight + zgImg.height;
          
          for (let j = 0; j < this.drawList.length; j++) {
            let _d = this.drawList[j];
            let d = JSON.parse(JSON.stringify(_d));
            d.blockIndex = i;
            
            if (!("move" in d)) {
              zgMarkList.push(d);
              continue;
            }
            
            let x = d.scaleX * rectWidth;
            let y = d.scaleY * rectHeight;
            
            if (d.type == 3 || d.type == 4) {
              if (x < zgImg.width && y >= beginHeight && y <= endHeight) {
                d.scaleX1 = x / zgImg.width;
                d.scaleY1 = (d.scaleY * rectHeight - beginHeight) / zgImg.height;
                if (d.scaleY1 > 1) d.scaleY1 = 1;
                if (d.type == 99) { cdScore = cdScore + d.score; isCd = true; }
                zgMarkList.push(d);
              } else if (zgCount == 1) {
                if (x >= zgImg.width) d.scaleX1 = 1;
                if (y >= endHeight) d.scaleY1 = 1;
                if (y < beginHeight) d.scaleY1 = 0;
                if (d.type == 99) { cdScore = cdScore + d.score; isCd = true; }
                zgMarkList.push(d);
              }
            } else {
              if (x < zgImg.width && y >= beginHeight && y <= endHeight) {
                d.scaleX1 = x / zgImg.width;
                d.scaleY1 = (d.scaleY * rectHeight - beginHeight) / zgImg.height;
                if (d.scaleY1 > 1) d.scaleY1 = 1;
                if (d.type == 99) { cdScore = cdScore + d.score; isCd = true; }
                zgMarkList.push(d);
              } else if (zgCount == 1) {
                if (x >= zgImg.width) d.scaleX1 = 1;
                if (y >= endHeight) d.scaleY1 = 1;
                if (y < beginHeight) d.scaleY1 = 0;
                if (d.type == 99) { cdScore = cdScore + d.score; isCd = true; }
                zgMarkList.push(d);
              }
            }
          }
          
          let zgMark = { points: zgMarkList, scoreInfo: o };
          if (this.topicType == 'FillBlank') {
            this.fillBlankList = [];
            zgMark.isQuickScore = this.isQuickScore;
            if (this.isQuickScore) {
              for (let k = 0; k < this.drawList.length; k++) {
                if (this.drawList[k].type == 100) {
                  let fobj = JSON.parse(JSON.stringify(this.drawList[k]));
                  fobj.score = 0;
                  if ("color" in fobj) delete fobj.color;
                  this.fillBlankList.push(fobj);
                }
              }
            }
          }
          if (this.isEdit) {
            zgMark.power = 1;
            zgMark.color = 'darkred';
          }
          
          let zg = { id: zgId, status: 'YY', score: o.score, markRecord: JSON.stringify(zgMark), teacherId: this.userInfo.id, drawImg: null };
          zgList.push(zg);
        }
        
        if (isCd && cdScore >= 0 && cdScore != o.score) {
          this.$alert('踩点打分总分:' + cdScore + '，与计算分:' + o.score + ' 不一致！', '提示');
          return;
        }
        
        let checkZgList = this.rpSubmitScoreCheck(zgList);
        let param = { controllerName: 'examTask', methodName: '/updateZg', param: { examId: XEUtils.toNumber(this.examIdVal), zgList: checkZgList, menuType: menuType } };
        // simpleApi.post(param).then(({ result: { code, data } }) => {

        // 将这里的回调改为 async
        let result = await simpleApi.post(param);
        let { result: { code, data } } = result;

          if (code == 0) {
            this.$message({ message: '阅卷打分成功！', type: 'success', duration: 2000 });
            this.showZg = false;
            this.drawList = [];
            this.selZgInfo = null;
            // 重新加载数据
            this.loadZgList();
            // this.loadExamPages();

            await  this.reloadStudentData()


          } else {
            this.$alert('阅卷失败！' + data, '提示');
          }
          this.loading = false;
        // });
      },
      
      rpSubmitScoreRecheck(o) {
        let zgIds = this.selZgInfo?.zgIds;
        if (!zgIds || zgIds.length === 0) return;
        
        let menuType = false;
        let zgList = [];
        let isCd = false, cdScore = 0;
        let rect = this.myCanvas.getBoundingClientRect();
        let rectWidth = rect.width, rectHeight = rect.height;
        let beginHeight = 0, endHeight = 0;
        let zgCount = zgIds.length;
        let zgMarkList = [];
        
        for (let i = 0; i < zgCount; i++) {
          let zgId = zgIds[i];
          let zgImg = this.selZgInfo["zg" + (i + 1)];
          if (i > 0) beginHeight = endHeight;
          endHeight = endHeight + zgImg.height;
          
          for (let j = 0; j < this.drawList.length; j++) {
            let _d = this.drawList[j];
            let d = JSON.parse(JSON.stringify(_d));
            d.blockIndex = i;
            
            if (!("move" in d)) {
              zgMarkList.push(d);
              continue;
            }
            
            let x = d.scaleX * rectWidth;
            let y = d.scaleY * rectHeight + d.h / 2;
            
            if (d.type == 3 || d.type == 4) {
              if (x < zgImg.width && y >= beginHeight && y <= endHeight) {
                d.scaleX1 = x / zgImg.width;
                d.scaleY1 = (d.scaleY * rectHeight - beginHeight) / zgImg.height;
                if (d.scaleY1 > 1) d.scaleY1 = 1;
                if (d.type == 99) { cdScore = cdScore + d.score; isCd = true; }
                zgMarkList.push(d);
              } else if (zgCount == 1) {
                if (x >= zgImg.width) d.scaleX1 = 1;
                if (y >= endHeight) d.scaleY1 = 1;
                if (y < beginHeight) d.scaleY1 = 0;
                if (d.type == 99) { cdScore = cdScore + d.score; isCd = true; }
                zgMarkList.push(d);
              }
            } else {
              if (x < zgImg.width && y >= beginHeight && y <= endHeight) {
                d.scaleX1 = x / zgImg.width;
                d.scaleY1 = (d.scaleY * rectHeight - beginHeight) / zgImg.height;
                if (d.scaleY1 > 1) d.scaleY1 = 1;
                if (d.type == 99) { cdScore = cdScore + d.score; isCd = true; }
                zgMarkList.push(d);
              } else if (zgCount == 1) {
                if (x >= zgImg.width) d.scaleX1 = 1;
                if (y >= endHeight) d.scaleY1 = 1;
                if (y < beginHeight) d.scaleY1 = 0;
                if (d.type == 99) { cdScore = cdScore + d.score; isCd = true; }
                zgMarkList.push(d);
              }
            }
          }
          
          let zgMark = { points: zgMarkList, scoreInfo: o };
          if (this.topicType == 'FillBlank') {
            this.fillBlankList = [];
            zgMark.isQuickScore = this.isQuickScore;
            if (this.isQuickScore) {
              for (let k = 0; k < this.drawList.length; k++) {
                if (this.drawList[k].type == 100) {
                  let fobj = JSON.parse(JSON.stringify(this.drawList[k]));
                  fobj.score = 0;
                  if ("color" in fobj) delete fobj.color;
                  this.fillBlankList.push(fobj);
                }
              }
            }
          }
          if (this.isEdit) {
            zgMark.power = 1;
            zgMark.color = 'darkred';
          }
          
          let zg = { id: zgId, status: 'YY', score: o.score, markRecord: JSON.stringify(zgMark), teacherId: this.userInfo.id, drawImg: null };
          zgList.push(zg);
        }
        
        if (isCd && cdScore >= 0 && cdScore != o.score) {
          this.$alert('踩点打分总分:' + cdScore + '，与计算分:' + o.score + ' 不一致！', '提示');
          return;
        }
        
        let param = { controllerName: 'examTask', methodName: '/updateZg', param: { examId: XEUtils.toNumber(this.examIdVal), zgList: zgList, menuType: menuType } };
        
        simpleApi.post(param).then(({ result: { code, data } }) => {
          if (code == 0) {
            this.$message({ message: '复核打分成功！', type: 'success', duration: 2000 });
            this.showZg = false;
            this.drawList = [];
            this.selZgInfo = null;
            this.loadZgList();
            this.loadExamPages();
          } else {
            this.$alert('阅卷失败！' + data, '提示');
          }
          this.loading = false;
        });
      },
      
      rpSubmitScoreCheck(zgList) {
        if (!Array.isArray(zgList) || zgList.length === 0) return zgList;
        let firstItem = zgList.find(item => item.markRecord != null && item.markRecord !== '');
        if (!firstItem) return zgList;
        zgList.forEach(element => {
          if (element.markRecord == null || element.markRecord == undefined || element.markRecord == '') {
            element.markRecord = firstItem.markRecord;
          }
        });
        return zgList;
      },
      
      submitNext() {
        this.examImageList = [];
        this.drawList = [];
        this.selZgInfo = null;
        this.showZg = false;
        this.drawMode = -1;
      },
      
      reEdit() {
        for (let i = 0; i < this.drawList.length; i++) {
          let d = this.drawList[i];
          d.power = 0;
          d.color = 'red';
        }
      },
      
      openViewer() {
        this.showViewer = true;
      },
      
      closeViewer() {
        this.showViewer = false;
      },
      
      keyS() {
        // 快捷键 S - 下一题（如果需要的话）
        if (this.selZgInfo) {
          this.submitNext();
        }
      },
      
      keyW() {
        // 快捷键 W - 上一题（如果需要的话）
      },
      // 新增方法：重新加载学生数据
      // 在 methods 中添加
      async reloadStudentData2() {
          this.loading = true;
          
          try {
              // 1. 重新加载主观题列表
              await this.loadZgList();
              
              // 2. 重新加载底图
              await this.loadExamPages();
              
              // 3. 如果当前有打开的主观题窗口，重新加载它的数据
              if (this.showZg && this.selZgInfo) {
                  let currentExamSeq = this.selZgInfo.examSeq;
                  let box = this.myCanvas1List.find(item => item.examSeq === currentExamSeq) ||
                            this.myCanvas2List.find(item => item.examSeq === currentExamSeq);
                  if (box) {
                      await this.loadZgExam(box);
                  }
              }
          } catch (error) {
              console.error('reloadStudentData error:', error);
          } finally {
              this.loading = false;
          }
      },
      async reloadStudentData3() {
        this.loading = true;
        
        try {
            // 重要：清空 drawZgList，否则绘制时会认为已存在而不重新绘制
            this.drawZgList = [];
            
            // 1. 重新加载主观题列表
            await this.loadZgList();
            
            // 2. 重新加载底图
            await this.loadExamPages();
            
            // 3. 如果当前有打开的主观题窗口，重新加载它的数据
            if (this.showZg && this.selZgInfo) {
                let currentExamSeq = this.selZgInfo.examSeq;
                let box = this.myCanvas1List.find(item => item.examSeq === currentExamSeq) ||
                          this.myCanvas2List.find(item => item.examSeq === currentExamSeq);
                if (box) {
                    await this.loadZgExam(box);
                }
            }
        } catch (error) {
            console.error('reloadStudentData error:', error);
        } finally {
            this.loading = false;
        }
      },
      async reloadStudentData() {
        this.loading = true;
        
        try {
            // 清空缓存
            this.drawZgListCache = [];
            this.drawList = [];
            
            // 重新加载主观题列表
            await this.loadZgList();
            
            // 重新加载底图 - 使用 nextTick 确保 DOM 更新完成
            await this.$nextTick();
            await this.loadExamPages();
            
            // 如果当前有打开的主观题窗口，重新加载它的数据
            // if (this.showZg && this.selZgInfo) {
            //     let currentExamSeq = this.selZgInfo.examSeq;
            //     let box = (this.myCanvas1List || []).find(item => item.examSeq === currentExamSeq) ||
            //               (this.myCanvas2List || []).find(item => item.examSeq === currentExamSeq);
            //     if (box) {
            //         await this.loadZgExam(box);
            //     }
            // }
        } catch (error) {
            console.error('reloadStudentData error:', error);
        } finally {
            this.loading = false;
        }
    },
      // 新增方法：重新绘制底图（不重新加载图片，只重新绘制批阅记录）
      redrawBottomCanvas() {
        if (!this.tableData) return;
        
        // 重新绘制第一页
        let canvas1 = document.getElementById("myCanvas1");
        if (canvas1 && canvas1.getContext) {
          let ctx1 = canvas1.getContext('2d');
          // 重新绘制批阅记录（需要触发 cardInfoAndImage 中的批阅记录绘制）
          this.cardInfoAndImage(ctx1, this.tableData, 1, 1);
        }
        
        // 重新绘制第二页
        let canvas2 = document.getElementById("myCanvas2");
        if (canvas2 && canvas2.getContext) {
          let ctx2 = canvas2.getContext('2d');
          this.cardInfoAndImage(ctx2, this.tableData, 2, 1);
        }
      },
    }
  }
  </script>
  
  <style lang="scss" type="text/scss" rel="stylesheet/scss">
  .rightPage {
    .status-error {
      color: red;
    }
    .el-form-item__label {
      font-size: 16px;
      color: black;
    }
  }
  </style>